import './polyfills';

import { Components } from './decorators/components';

import { Header } from './components/header/header.component';
import { Icon } from './components/icon/icon.component';
import { Button } from './components/button/button.component';
import { Link } from './components/link/link.component';
import { FeatureBadge } from './components/feature-badge/feature-badge.component';
import { Breadcrumbs } from './components/breadcrumbs/breadcrumbs.component';
import { PageIntro } from './components/page-intro/page-intro.component';
import { CookiePolicy } from './components/cookie-policy/cookie-policy.component';
import { ValueProposition } from './components/value-proposition/value-proposition.component';
import { ValuePropositionItem } from './components/value-proposition-item/value-proposition-item.component';
import { HeroBanner } from './components/hero-banner/hero-banner.component';
import { HeroBannerItem } from './components/hero-banner-item/hero-banner-item.component';
import { HeroBannerItemCol } from './components/hero-banner-item-col/hero-banner-item-col.component';
import { HeroBannerItemFull } from './components/hero-banner-item-full/hero-banner-item-full.component';
import { ResponsiveImage } from './components/responsive-image/responsive-image.component';
import { PromotionalBanner } from './components/promotional-banner/promotional-banner.component';
import { PromotionalBannerItem } from './components/promotional-banner-item/promotional-banner-item.component';
import { ProductOffering } from './components/product-offering/product-offering.component';
import { ProductCard } from './components/product-card/product-card.component';
import { CrossSell } from './components/cross-sell/cross-sell.component';
import { CrossSellItem } from './components/cross-sell-item/cross-sell-item.component';
import { SupportingContent } from './components/supporting-content/supporting-content.component';
import { SupportingContentCard } from './components/supporting-content-card/supporting-content-card.component';
import { SupportingContentItem } from './components/supporting-content-item/supporting-content-item.component';
import { DetailedProductCard } from './components/detailed-product-card/detailed-product-card.component';
import { FooterContainer } from './components/footer/footer.component';
import { Lifestyle } from './components/lifestyle/lifestyle.component';
import { LifestyleItem } from './components/lifestyle-item/lifestyle-item.component';
import { Carousel } from './components/carousel/carousel.component';
import { CarouselItem } from './components/carousel-item/carousel-item.component';
import { ImageCarousel } from './components/image-carousel/image-carousel.component';
import { ImageCarouselItem } from './components/image-carousel-item/image-carousel-item.component';
import { OurCampaigns } from './components/our-campaigns/our-campaigns.component';
import { OurCampaignsGrid } from './components/our-campaigns-grid/our-campaigns-grid.component';
import { OurCampaignsItem } from './components/our-campaigns-item/our-campaigns-item.component';
import { ListOfLinks } from './components/list-of-links/list-of-links.component';
import { ListOfNumbers } from './components/list-of-numbers/list-of-numbers.component';
import { AddOn } from './components/add-on/add-on.component';
import { NeedsGoals } from './components/needs-goals/needs-goals.component';
import { NeedsGoalsItem } from './components/needs-goals-item/needs-goals-item.component';
import { ShoppingPromo } from './components/shopping-promo/shopping-promo.component';
import { Tabs } from './components/tabs/tabs.component';
import { TabItem } from './components/tab-item/tab-item.component';
import { Accordion } from './components/accordion/accordion.component';
import { SelfService } from './components/self-service/self-service.component';
import { SelfServiceItem } from './components/self-service-item/self-service-item.component';
import { ProductFilter } from './components/product-filter/product-filter.component';
import { ProductFilterDropdown } from './components/product-filter-dropdown/product-filter-dropdown.component';
import { SwitchToBusiness } from './components/switch-to-business/switch-to-business.component';
import { Bizconnect } from './components/bizconnect/bizconnect.component';
import { SwitchToStandardBank } from './components/switch-to-standard-bank/switch-to-standard-bank.component';
import { WantToMenu } from './components/want-to-menu/want-to-menu.component';
import { Testimonials } from './components/testimonials/testimonials.component';
import { Comparison } from './components/comparison/comparison.component';
import { InterestRates } from './components/interest-rates/interest-rates.component';
import { CountrySelector } from './components/country-selector/country-selector.component';
import { Search } from './components/search/search.component';
import { HeaderBannerVideo } from './components/header-banner-video/header-banner-video.component';
import { HorizontalButtons } from './components/horizontal-buttons/horizontal-buttons.component';
import { HorizontalButtonsItem } from './components/horizontal-buttons-item/horizontal-buttons-item.component';
import { SearchResults } from './components/search-results/search-results.component';
import { SearchResultsItem } from './components/search-results-item/search-results-item.component';
import { Pagination } from './components/pagination/pagination.component';
import { SigninModule } from './components/signin-module/signin-module.component';
import { Share } from './components/share/share.component';
import { AdvancedSearch } from './components/advanced-search/advanced-search.component';
import { CallMeBack } from './components/call-me-back/call-me-back.component';
import { ApplyNow } from './components/apply-now/apply-now.component';
import { Enquiry } from './components/enquiry/enquiry.component';
import { AdditionalRequirements } from './components/additional-requirements/additional-requirements.component';
import { Attachments } from './components/attachments/attachments.component';
import { Video } from './components/video/video.component';
import { ContentCard } from './components/content-card/content-card.component';
import { ContentCardItem } from './components/content-card-item/content-card-item.component';
import { ContentCards } from './components/content-cards/content-cards.component';
import { SupportingDetailCard } from './components/supporting-detail-card/supporting-detail-card.component';
import { Ucount } from './components/ucount/ucount.component';
import { TablePopup } from './components/table-popup/table-popup.component';
import { TablePopupChecklist } from './components/table-popup-checklist/table-popup-checklist.component';
import { Map } from './components/map/map.component';
import { GetTheAppBanner } from './components/get-the-app-banner/get-the-app-banner.component';
import { RichTextModal } from './components/rich-text-modal/rich-text-modal.component';
import { BranchLocator } from './components/branch-locator/branch-locator.component';
import { BranchLocatorItem } from './components/branch-locator-item/branch-locator-item.component';
import { ProductOfferingSlider } from './components/product-offering-slider/product-offering-slider.component';
import { ContactUs } from './components/contact-us/contact-us.component';
import { ContactUsItem } from './components/contact-us-item/contact-us-item.component';
import { Address } from './components/address/address.component';
import { Calculators } from './components/calculators/calculators.component';
import { CalculatorItem } from './components/calculator-item/calculator-item.component';
import { CalculatorForm } from './components/calculator-form/calculator-form.component';
import { CalculatorModals } from './components/calculator-modals/calculator-modals.component';
import { CalculatorsPersonalloansTest } from './components-wpbbsa/calculators-personalloans-test/calculators-personalloans-test.component';
import { FormContainer } from './components/form-container/form-container.component';
import { FormContainerWizard } from './components/form-container-wizard/form-container-wizard.component';
import { FormContainerRelatedLinks } from './components-wpbbsa/form-container-related-links/form-container-related-links.component';
import { FormContainerFields } from './components/form-container-fields/form-container-fields.component';
import { BrowserDetection } from './components/browser-detection/browser-detection.component';
import { VideoCarousel } from './components/video-carousel/video-carousel.component';
import { VideoCarouselItem } from './components/video-carousel-item/video-carousel-item.component';
import { FormItemDfcPersonal } from './components/form-item-dfc-personal/form-item-dfc-personal.component';
import { FormItemDfcBusiness } from './components/form-item-dfc-business/form-item-dfc-business.component';
import { FormItemInsurancePersonal } from './components/form-item-insurance-personal/form-item-insurance-personal.component';
import { FormItemAccessQuote } from './components/form-item-access-quote/form-item-access-quote.component';
import { FormItemHomeServicesVas } from './components-wpbbsa/form-item-home-services-vas/form-item-home-services-vas.component';
import { FormItemMailForm } from './components/form-item-mail-form/form-item-mail-form.component';
import { FormItemBusinessLendingCmb } from './components/form-item-business-lending-cmb/form-item-business-lending-cmb.component';
import { FormItemAccessQuotePc } from './components-wpbbsa/form-item-access-quote-pc/form-item-access-quote-pc.component';
import { FormItemAccessQuoteUpl } from './components-wpbbsa/form-item-access-quote-upl/form-item-access-quote-upl.component';
import { FormItemHsApplyNow } from './components-wpbbsa/form-item-hs-apply-now/form-item-hs-apply-now.component';
import { FormItemHsVasStatistics } from './components-wpbbsa/form-item-hs-vas-statistics/form-item-hs-vas-statistics.component';
import { FormItemWinACar } from './components-wpbbsa/form-item-win-a-car/form-item-win-a-car.component';
import { FormItemBlApplyNow } from './components-wpbbsa/form-item-bl-apply-now/form-item-bl-apply-now.component';
import { FormItemBlApplyNowPc } from './components-wpbbsa/form-item-bl-apply-now-pc/form-item-bl-apply-now-pc.component';
import { FormItemAgriBusinessFinanceFarmers } from './components-wpbbsa/form-item-agri-business-finance-farmers/form-item-agri-business-finance-farmers.component';
import { FormItemLifeCoverInsurance } from './components-wpbbsa/form-item-life-cover-insurance/form-item-life-cover-insurance.component';
import { FormItemStansure } from './components-wpbbsa/form-item-stansure/form-item-stansure.component';
import { FormItemEmployerValueBanking } from './components-wpbbsa/form-item-employer-value-banking/form-item-employer-value-banking.component';
import { FormItemMvno } from './components-wpbbsa/form-item-mvno/form-item-mvno.component';
import { FormItemGapAssistCmb } from './components-wpbbsa/form-item-gap-assist-cmb/form-item-gap-assist-cmb.component';
import { FormItemFlexibleFuneralPlanCmb } from './components-wpbbsa/form-item-flexible-funeral-plan-cmb/form-item-flexible-funeral-plan-cmb.component';
import { FormItemHsPropertyInspections } from './components-wpbbsa/form-item-hs-property-inspections/form-item-hs-property-inspections.component';
import { FormItemBusinessLendingVafCmb } from './components-wpbbsa/form-item-business-lending-vaf-cmb/form-item-business-lending-vaf-cmb.component';
import { FormItemPaiaRequest } from './components-wpbbsa/form-item-paia-request/form-item-paia-request.component';
import { CalculatorsBusinessloansV2 } from './components-wpbbsa/calculators-businessloans-v2/calculators-businessloans-v2.component';
import { CalculatorPersonalloansV2Form } from './components-wpbbsa/calculator-personalloans-v2-form/calculator-personalloans-v2-form.component';
import { CalculatorPersonalloansV2Item } from './components-wpbbsa/calculator-personalloans-v2-item/calculator-personalloans-v2-item.component';
import { CalculatorsPersonalloansV2 } from './components-wpbbsa/calculators-personalloans-v2/calculators-personalloans-v2.component';
import { FormItemFnTemporaryResidentBanking } from './components-wpbbsa/form-item-fn-temporary-resident-banking/form-item-fn-temporary-resident-banking.component';

import { SitemapComponent } from './components/sitemap/sitemap.component';
import { FileListFilterNone } from './components/file-list-filter-none/file-list-filter-none.component';
import { TabsFaqs } from './components/tabs-faqs/tabs-faqs.component';
import { CategoryFaq } from './components/category-faq/category-faq.component';
import { ProductOfferingExchange } from './components/product-offering-exchange/product-offering-exchange.component';
import { ComparisonExchange } from './components/comparison-exchange/comparison-exchange.component';
import { DetailedProductCardExchange } from './components/detailed-product-card-exchange/detailed-product-card-exchange.component';
import { FormCheckEligibilityOptimumBankAccount } from './components/form-check-eligibility-optimum-bank-account/form-check-eligibility-optimum-bank-account.component';
import { FormCheckEligibilityPlatinumOptimumBankAccount } from './components/form-check-eligibility-platinum-optimum-bank-account/form-check-eligibility-platinum-optimum-bank-account.component';
import { FormCheckEligibilitySeafarerBankAccount } from './components/form-check-eligibility-seafarer-bank-account/form-check-eligibility-seafarer-bank-account.component';
import { FormCheckEligibilitySavingsAccount } from './components/form-check-eligibility-savings-account/form-check-eligibility-savings-account.component';
import { FormCheckEligibilityBusiness } from './components/form-check-eligibility-business/form-check-eligibility-business.component';
import { FormItemCmbEligibilityPersonal } from './components/form-item-cmb-eligibility-personal/form-item-cmb-eligibility-personal.component';
import { FormItemCmbEligibilityBusiness } from './components/form-item-cmb-eligibility-business/form-item-cmb-eligibility-business.component';
import { ProfileTile } from './components/profile-tile/profile-tile.component';
import { FileListFilterCategory } from './components/file-list-filter-category/file-list-filter-category.component';
import { FileListFilterYear } from './components/file-list-filter-year/file-list-filter-year.component';
import { FormItemCmbEligibilityFeedback } from './components/form-item-cmb-eligibility-feedback/form-item-cmb-eligibility-feedback.component';
import { FormItemCmbEligibilityNeedHelp } from './components/form-item-cmb-eligibility-need-help/form-item-cmb-eligibility-need-help.component';
import { FormCheckEligibilityBusinessStrataAccount } from './components/form-check-eligibility-business-strata-account/form-check-eligibility-business-strata-account.component';
import { ProductOfferingSliderExchange } from './components/product-offering-slider-exchange/product-offering-slider-exchange.component';
import { CarouselArticleList } from './components/carousel-article-list/carousel-article-list.component';
import { CarouselArticleListItem } from './components/carousel-article-list-item/carousel-article-list-item.component';
import { ArticleCombo } from './components/article-combo/article-combo.component';
import { ArticleComboItem } from './components/article-combo-item/article-combo-item.component';
import { CarouselArticleRelatedMediaFilesItem } from './components/carousel-article-related-media-files-item/carousel-article-related-media-files-item.component';
import { ArticleFilter } from './components/article-filter/article-filter.component';
import { ArticleComboLargeImages } from './components/article-combo-large-images/article-combo-large-images.component';
import { BannerMidPageWhite } from './components/banner-mid-page-white/banner-mid-page-white.component';
import { BannerMidPageWhiteItem } from './components/banner-mid-page-white-item/banner-mid-page-white-item.component';
import { BannerBlueSmall } from './components/banner-blue-small/banner-blue-small.component';
import { BannerBlueSmallItem } from './components/banner-blue-small-item/banner-blue-small-item.component';
import { PageIntroArticle } from './components/page-intro-article/page-intro-article.component';
import { ArticlePageImageCarousel } from './components/article-page-image-carousel/article-page-image-carousel.component';
import { ArticlePageImageCarouselItem } from './components/article-page-image-carousel-item/article-page-image-carousel-item.component';
import { ArticlePageVideoCarousel } from './components/article-page-video-carousel/article-page-video-carousel.component';
import { ArticlePageVideoCarouselItem } from './components/article-page-video-carousel-item/article-page-video-carousel-item.component';
import { FilterBuilder } from './components/filter-builder/filter-builder.component';
import { Newsletter } from './components/newsletter/newsletter.component';
import { DealsListFilterYear } from './components/deals-list-filter-year/deals-list-filter-year.component';
import { DealsList } from './components/deals-list/deals-list.component';
import { DealsListItem } from './components/deals-list-item/deals-list-item.component';
import { DealsFeature } from './components/deals-feature/deals-feature.component';
import { ProfileList } from './components/profile-list/profile-list.component';
import { ProfileListItem } from './components/profile-list-item/profile-list-item.component';
import { AddOnInsights } from './components/add-on-insights/add-on-insights.component';
import { DealsBlueBlockAddOn } from './components/deals-blue-block-add-on/deals-blue-block-add-on.component';
import { ProfileListCarousel } from './components/profile-list-carousel/profile-list-carousel.component';
import { ProfileListCarouselItem } from './components/profile-list-carousel-item/profile-list-carousel-item.component';
import { CarouselFullwidth } from './components/carousel-fullwidth/carousel-fullwidth.component';
import { CarouselFullwidthItem } from './components/carousel-fullwidth-item/carousel-fullwidth-item.component';
import { BannerHeroBlueFloatee } from './components/banner-hero-blue-floatee/banner-hero-blue-floatee.component';
import { BannerHeroBlueFloateeItem } from './components/banner-hero-blue-floatee-item/banner-hero-blue-floatee-item.component';
import { BannerHeroBlueSmallLogos } from './components/banner-hero-blue-small-logos/banner-hero-blue-small-logos.component';
import { BannerHeroBlueSmallLogosItem } from './components/banner-hero-blue-small-logos-item/banner-hero-blue-small-logos-item.component';
import { BannerMidPageFullWidth } from './components/banner-mid-page-full-width/banner-mid-page-full-width.component';
import { BannerMidPageFullWidthItem } from './components/banner-mid-page-full-width-item/banner-mid-page-full-width-item.component';
import { ReportIntro } from './components/report-intro/report-intro.component';
import { ArticlePageNewsIntro } from './components/article-page-news-intro/article-page-news-intro.component';
import { EventListFilterYearTopic } from './components/event-list-filter-year-topic/event-list-filter-year-topic.component';
import { ArtworkTile } from './components/artwork-tile/artwork-tile.component';
import { BannerHeroImageFull } from './components/banner-hero-image-full/banner-hero-image-full.component';
import { BannerHeroImageFullItem } from './components/banner-hero-image-full-item/banner-hero-image-full-item.component';
import { ImageRelatedImageStack } from './components/image-related-image-stack/image-related-image-stack.component';
import { Podcast } from './components/podcast/podcast.component';
import { ContactAccordionSingle } from './components/contact-accordion-single/contact-accordion-single.component';
import { ShareIconsLeft } from './components/share-icons-left/share-icons-left.component';
import { ShareIconsRight } from './components/share-icons-right/share-icons-right.component';
import { PressReleases } from './components/press-releases/press-releases.component';
import { ShareIconsBanner } from './components/share-icons-banner/share-icons-banner.component';
import { ShareIconsHorizontal } from './components/share-icons-horizontal/share-icons-horizontal.component';
import { CarouselArticleSmall } from './components/carousel-article-small/carousel-article-small.component';
import { CarouselArticleSmallItem } from './components/carousel-article-small-item/carousel-article-small-item.component';
import { ContactTile2CountryIndivStack } from './components/contact-tile2-country-indiv-stack/contact-tile2-country-indiv-stack.component';
import { ArticlePodcast } from './components/article-podcast/article-podcast.component';
import { ContactTile3CountryIndivStack } from './components/contact-tile3-country-indiv-stack/contact-tile3-country-indiv-stack.component';
import { VideoRelatedVideoStack } from './components/video-related-video-stack/video-related-video-stack.component';
import { BannerMidPageVideo } from './components/banner-mid-page-video/banner-mid-page-video.component';
import { PodcastRelatedPodcastStack } from './components/podcast-related-podcast-stack/podcast-related-podcast-stack.component';
import { RateTileFullWidth } from './components/rate-tile-full-width/rate-tile-full-width.component';
import { ContentListStack } from './components/content-list-stack/content-list-stack.component';
import { ContactCountryAccordions } from './components/contact-country-accordions/contact-country-accordions.component';
import { FollowMediaIcons } from './components/follow-media-icons/follow-media-icons.component';
import { InfographicPage } from './components/infographic-page/infographic-page.component';
import { Unsubscribe } from './components/unsubscribe/unsubscribe.component';
import { ContentCardStack } from './components/content-card-stack/content-card-stack.component';
import { AccordionVersionTwo } from './components/accordion-version-two/accordion-version-two.component';
import { TimelineVertical } from './components/timeline-vertical/timeline-vertical.component';
import { FileListFilterTopic } from './components/file-list-filter-topic/file-list-filter-topic.component';
import { InfographicPageBluebox } from './components/infographic-page-bluebox/infographic-page-bluebox.component';
import { InfographicPageCenter } from './components/infographic-page-center/infographic-page-center.component';
import { InfographicPageLandscape } from './components/infographic-page-landscape/infographic-page-landscape.component';
import { InfographicPageNoblurb } from './components/infographic-page-noblurb/infographic-page-noblurb.component';
import { ContentFocusDisplays } from './components/content-focus-displays/content-focus-displays.component';
import { AccoladesCarousel } from './components/accolades-carousel/accolades-carousel.component';
import { AccoladesCarouselItem } from './components/accolades-carousel-item/accolades-carousel-item.component';
import { AccoladesListSimple } from './components/accolades-list-simple/accolades-list-simple.component';
import { MarketRates } from './components/market-rates/market-rates.component';
import { TableContext } from './components/table-context/table-context.component';
import { AccoladesListBlocks } from './components/accolades-list-blocks/accolades-list-blocks.component';
import { UnsubscribeBasic } from './components/unsubscribe-basic/unsubscribe-basic.component';
import { EventCard } from './components/event-card/event-card.component';
import { EventList } from './components/event-list/event-list.component';
import { EventListX2 } from './components/event-list-x2/event-list-x2.component';
import { EventTile } from './components/event-tile/event-tile.component';
import { FormItemNigeriaAccountEnquiry } from './components/form-item-nigeria-account-enquiry/form-item-nigeria-account-enquiry.component';
import { FormItemNigeriaFeedback } from './components/form-item-nigeria-feedback/form-item-nigeria-feedback.component';
import { FormItemNigeriaNeedHelp } from './components/form-item-nigeria-need-help/form-item-nigeria-need-help.component';
import { ImageWithLargeTextLeft } from './components/image-with-large-text-left/image-with-large-text-left.component';
import { BannerThreeStepPromo } from './components/banner-three-step-promo/banner-three-step-promo.component';
import { ContentDisplayCardsIconsWithImage } from './components/content-display-cards-icons-with-image/content-display-cards-icons-with-image.component';
import { FileDownloadWithImage } from './components/file-download-with-image/file-download-with-image.component';
import { ImageWithLargeTextRight } from './components/image-with-large-text-right/image-with-large-text-right.component';
import { LogoCarousel } from './components/logo-carousel/logo-carousel.component';
import { LogoCarouselItem } from './components/logo-carousel-item/logo-carousel-item.component';
import { ContentDisplayWithNoIconsAndImage } from './components/content-display-with-no-icons-and-image/content-display-with-no-icons-and-image.component';
import { ContentDisplayCardsWithIconsOrTitle } from './components/content-display-cards-with-icons-or-title/content-display-cards-with-icons-or-title.component';
import { CtaWithImage } from './components/cta-with-image/cta-with-image.component';
import { TabsStandalone } from './components/tabs-standalone/tabs-standalone.component';
import { ImageWithTextBlock } from './components/image-with-text-block/image-with-text-block.component';
import { ImageWithText } from './components/image-with-text/image-with-text.component';
import { SocialFeeds } from './components/social-feeds/social-feeds.component';
import { ImageFullWithText } from './components/image-full-with-text/image-full-with-text.component';
import { FormBuilder } from './components/form-builder/form-builder.component';
import { FormItemGenericForm } from './components/form-item-generic-form/form-item-generic-form.component';
import { GlossaryBuild } from './components/glossary-build/glossary-build.component';
import { ScriptImage } from './components/script-image/script-image.component';
import { DealsBannerSmallLogos } from './components/deals-banner-small-logos/deals-banner-small-logos.component';
import { DealsBannerSmallLogosItem } from './components/deals-banner-small-logos-item/deals-banner-small-logos-item.component';

import './scss/main.scss';

@Components({
	register: [
		Header,
		Icon,
		Button,
		Link,
		FeatureBadge,
		Breadcrumbs,
		PageIntro,
		CookiePolicy,
		ResponsiveImage,
		ValueProposition,
		ValuePropositionItem,
		HeroBanner,
		HeroBannerItem,
		HeroBannerItemCol,
		HeroBannerItemFull,
		PromotionalBanner,
		PromotionalBannerItem,
		ProductOffering,
		ProductFilter,
		ProductFilterDropdown,
		ProductCard,
		CrossSell,
		CrossSellItem,
		SupportingContent,
		SupportingContentCard,
		SupportingContentItem,
		DetailedProductCard,
		FooterContainer,
		ListOfLinks,
		ListOfNumbers,
		NeedsGoals,
		NeedsGoalsItem,
		ShoppingPromo,
		Lifestyle,
		LifestyleItem,
		Carousel,
		CarouselItem,
		ImageCarousel,
		ImageCarouselItem,
		OurCampaigns,
		OurCampaignsGrid,
		OurCampaignsItem,
		ImageCarouselItem,
		ListOfLinks,
		Tabs,
		TabItem,
		Accordion,
		SelfService,
		SelfServiceItem,
		AddOn,
		SwitchToBusiness,
		Bizconnect,
		SwitchToStandardBank,
		WantToMenu,
		Testimonials,
		InterestRates,
		Accordion,
		Comparison,
		CountrySelector,
		Search,
		HeaderBannerVideo,
		HorizontalButtons,
		HorizontalButtonsItem,
		SearchResults,
		SearchResultsItem,
		Pagination,
		SigninModule,
		Share,
		AdvancedSearch,
		CallMeBack,
		ApplyNow,
		Enquiry,
		AdditionalRequirements,
		Attachments,
		Video,
		ContentCard,
		ContentCardItem,
		ContentCards,
		SupportingDetailCard,
		Ucount,
		TablePopup,
		TablePopupChecklist,
		Map,
		GetTheAppBanner,
		RichTextModal,
		BranchLocator,
		BranchLocatorItem,
		ProductOfferingSlider,
		ContactUs,
		ContactUsItem,
		Address,
		Calculators,
		CalculatorItem,
		CalculatorForm,
		CalculatorModals,
		CalculatorsPersonalloansTest,
		FormContainer,
		FormContainerWizard,
		FormContainerRelatedLinks,
		FormContainerFields,
		FormContainerWizard,
		BrowserDetection,
		VideoCarousel,
		VideoCarouselItem,
		FormItemDfcPersonal,
		FormItemDfcBusiness,
		FormItemInsurancePersonal,
		FormItemAccessQuote,
		FormItemHomeServicesVas,
		FormItemMailForm,
		FormItemAccessQuotePc,
		FormItemAccessQuoteUpl,
		FormItemHsApplyNow,
		FormItemHsVasStatistics,
		FormItemWinACar,
		SitemapComponent,
		FormItemBlApplyNow,
		FormItemBlApplyNowPc,
		FormItemAgriBusinessFinanceFarmers,
		FormItemLifeCoverInsurance,
		FormItemStansure,
		FormItemEmployerValueBanking,
		FormItemMvno,
		FormItemHsPropertyInspections,
		FormItemBusinessLendingVafCmb,
		FormItemPaiaRequest,
		CalculatorsBusinessloansV2,
		CalculatorPersonalloansV2Form,
		CalculatorPersonalloansV2Item,
		CalculatorsPersonalloansV2,
		FormItemFnTemporaryResidentBanking,
		FormItemBusinessLendingCmb,
		FormItemGapAssistCmb,
		FormItemFlexibleFuneralPlanCmb,
		FileListFilterNone,
		TabsFaqs,
		CategoryFaq,
		ProductOfferingExchange,
		ComparisonExchange,
		DetailedProductCardExchange,
		FormCheckEligibilityOptimumBankAccount,
		FormCheckEligibilityPlatinumOptimumBankAccount,
		FormCheckEligibilitySeafarerBankAccount,
		FormCheckEligibilitySavingsAccount,
		FormCheckEligibilityBusiness,
		FormItemCmbEligibilityPersonal,
		FormItemCmbEligibilityBusiness,
		ProfileTile,
		FileListFilterCategory,
		FileListFilterYear,
		FormItemCmbEligibilityFeedback,
		FormItemCmbEligibilityNeedHelp,
		FormCheckEligibilityBusinessStrataAccount,
		ProductOfferingSliderExchange,
		CarouselArticleList,
		CarouselArticleListItem,
		ArticleCombo,
		ArticleComboItem,
		CarouselArticleRelatedMediaFilesItem,
		ArticleFilter,
		ArticleComboLargeImages,
		BannerMidPageWhite,
		BannerMidPageWhiteItem,
		BannerBlueSmall,
		BannerBlueSmallItem,
		PageIntroArticle,
		ArticlePageImageCarousel,
		ArticlePageImageCarouselItem,
		ArticlePageVideoCarousel,
		ArticlePageVideoCarouselItem,
		FilterBuilder,
		Newsletter,
		DealsListFilterYear,
		DealsList,
		DealsListItem,
		DealsFeature,
		ProfileList,
		ProfileListItem,
		AddOnInsights,
		DealsBlueBlockAddOn,
		ProfileListCarousel,
		ProfileListCarouselItem,
		CarouselFullwidth,
		CarouselFullwidthItem,
		BannerHeroBlueFloatee,
		BannerHeroBlueFloateeItem,
		BannerHeroBlueSmallLogos,
		BannerHeroBlueSmallLogosItem,
		BannerMidPageFullWidth,
		BannerMidPageFullWidthItem,
		ReportIntro,
		ArticlePageNewsIntro,
		EventListFilterYearTopic,
		ArtworkTile,
		BannerHeroImageFull,
		BannerHeroImageFullItem,
		ImageRelatedImageStack,
		Podcast,
		ContactAccordionSingle,
		ShareIconsLeft,
		ShareIconsRight,
		PressReleases,
		ShareIconsBanner,
		ShareIconsHorizontal,
		CarouselArticleSmall,
		CarouselArticleSmallItem,
		ContactTile2CountryIndivStack,
		ArticlePodcast,
		ContactTile3CountryIndivStack,
		VideoRelatedVideoStack,
		BannerMidPageVideo,
		PodcastRelatedPodcastStack,
		RateTileFullWidth,
		ContactCountryAccordions,
		FollowMediaIcons,
		ContentListStack,
		InfographicPage,
		Unsubscribe,
		ContentCardStack,
		AccordionVersionTwo,
		TimelineVertical,
		FileListFilterTopic,
		InfographicPageBluebox,
		InfographicPageCenter,
		InfographicPageLandscape,
		InfographicPageNoblurb,
		ContentFocusDisplays,
		AccoladesCarousel,
		AccoladesCarouselItem,
		AccoladesListSimple,
		MarketRates,
		TableContext,
		AccoladesListBlocks,
		UnsubscribeBasic,
		EventCard,
		EventList,
		EventListX2,
		EventTile,
		FormItemNigeriaAccountEnquiry,
		FormItemNigeriaFeedback,
		FormItemNigeriaNeedHelp,
		ImageWithLargeTextLeft,
		BannerThreeStepPromo,
		ContentDisplayCardsIconsWithImage,
		FileDownloadWithImage,
		ImageWithLargeTextRight,
		LogoCarousel,
		LogoCarouselItem,
		ContentDisplayWithNoIconsAndImage,
		ContentDisplayCardsWithIconsOrTitle,
		CtaWithImage,
		TabsStandalone,
		ImageWithTextBlock,
		ImageWithText,
		SocialFeeds,
		ImageFullWithText,
		FormBuilder,
		FormItemGenericForm,
		GlossaryBuild,
		ScriptImage,
		DealsBannerSmallLogos,
		DealsBannerSmallLogosItem,
		
	]
})
export class Kilimanjaro { }



// WEBPACK FOOTER //
// ./app.ts